/**
 * Human report title for a `report_type` key (e.g. "billing" -> "Billing"),
 * used by the Saved/Recents rail where only the backend report_type is on
 * hand (not the catalog template object). Reverse-looks-up the template
 * registry via the same name<->type map the catalog itself uses.
 */
import { getAllTemplates } from '../../../templates/index';
import { getReportTypeFromTemplateName } from '../../../utils/reportFieldConfig';

let titleByType = null;

function titleMap() {
  if (!titleByType) {
    titleByType = {};
    for (const t of getAllTemplates()) {
      titleByType[getReportTypeFromTemplateName(t.name)] = t.name;
    }
  }
  return titleByType;
}

function humanize(reportType) {
  return reportType
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function reportTitleForType(reportType) {
  if (!reportType) return '';
  return titleMap()[reportType] || humanize(reportType);
}
